import { IField } from '@features/forms'

/**
 * getValues
 * Returns a dict of field names mapped against their values for the
 * given list of form fields.
 */
export function getValues(fields: IField[]) {
  const values: any = {}
  for (const field of fields) {
    const { value } = field
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      values[field.name] = field.value
    }
  }
  return values
}
